import { PropsWithChildren } from 'react';
import { Auth } from 'firebase/auth';
import { useAuthManager } from './useAuthManager';

/**
 * Authentication Provider type.
 */
export type FirebaseAuthProviderProps = PropsWithChildren<{
    firebaseAuth: Auth;
}>;

/**
 * Authentication Context Provider.
 */
export function FirebaseAuthProvider({ firebaseAuth, children }: FirebaseAuthProviderProps) {
    useAuthManager(firebaseAuth);

    return children;
}
